import React from 'react';
import {
  CertificationFilter as CertificationFilterStyled,
  CertificationFilterLabel,
  Switch
} from './CertificationFilter.styles';
import { CertificationFilterProps } from 'models/CertificationFilterProps';
import { FormattedMessage } from 'react-intl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { TrustmarkImg } from './CertificationFilter.styles';
import { buildHref } from 'helpers/buildHref';
import { CERTIFICATE_TOGGLE } from 'services/data-test-attributes';

const CertificationFilter = ({
  hasValidCertificate,
  activeFilters,
  onParameterChange
}: CertificationFilterProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { pathname, query } = buildHref({
      ...activeFilters,
      hasValidCertificate: event.target.checked,
      page: undefined
    });

    onParameterChange({ pathname, query });
  };

  return (
    <CertificationFilterStyled>
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              data-test={CERTIFICATE_TOGGLE}
              checked={hasValidCertificate}
              onChange={handleChange}
              name="hasValidCertificate"
              color="default"
            />
          }
          label={
            <CertificationFilterLabel>
              <TrustmarkImg />
              <FormattedMessage
                id="FILTER.HAS_VALID_CERTIFICATE"
                tagName="span"
              />
            </CertificationFilterLabel>
          }
          labelPlacement="start"
          style={{
            marginLeft: 0,
            marginRight: -10,
            justifyContent: 'space-between'
          }}
        />
      </FormGroup>
      {hasValidCertificate}
    </CertificationFilterStyled>
  );
};
export default CertificationFilter;
